import React, { Component } from 'react';
import { isEmpty } from '../Common/Common';
import Top_Bar from '../Part_Sample/Top_Bar';
import Site_Cell from './Components/Site_Cell';

export default class MSM extends Component {
	constructor(props) {
		super(props);
		window.app.hideLoading();

		this.state = {

		}
	}

	render() {
		let style = {
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height - 55,
			overflow: 'auto'
		}

		let is_narrow_screen = false;
		if ((this.props.width - 10) < 400) is_narrow_screen = true;

		let is_display_all = false;
		if (isEmpty(this.props.param.msm_region_settings)) is_display_all = true;

		// No top bar for MSM
		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='noScrollBar'>
					<div style={{ display: !is_display_all ? 'none' : is_narrow_screen ? 'block' : 'flex', flexWrap: is_narrow_screen ? 'unset' : 'wrap' }}>
						{Object.keys(window.app.state.site_list).map((site_id) => {
							let site_info = window.app.state.site_list[site_id];
							if (!isEmpty(site_info)) {
								return (
									<Site_Cell
										width={this.props.width}
										height={this.props.height}
										colours={this.props.colours}
										site_id={site_id}
										site_info={site_info}
										receiver={this.props.receiver}
										is_narrow_screen={is_narrow_screen}
									/>
								)
							}
						})}
					</div>
					<div style={{ display: is_display_all ? 'none' : 'block' }}>
						{Object.keys(this.props.param.msm_region_settings).map((region_name) => {
							let site_list = this.props.param.msm_region_settings[region_name];
							let is_have_access = false;
							// Check that user has access to site
							for (let site_id of site_list) {
								if (!isEmpty(window.app.state.site_list[site_id])) {
									is_have_access = true;
									break;
								}
							}

							if (is_have_access) {
								return (
									<div>
										<span className='header' style={{ fontSize: 20 }}>{region_name}</span>
										<div style={{ display: is_narrow_screen ? 'block' : 'flex' }}>
											{site_list.map((site_id) => {
												let site_info = window.app.state.site_list[site_id];
												if (!isEmpty(site_info)) {
													return (
														<Site_Cell
															width={this.props.width}
															height={this.props.height}
															colours={this.props.colours}
															site_id={site_id}
															site_info={site_info}
															receiver={this.props.receiver}
															is_narrow_screen={is_narrow_screen}
														/>
													)
												}
											})}
										</div>
									</div>
								)
							}
						})}
					</div>
				</div>
			</div>
		)
	}
}